import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";
import { DateTime } from "luxon";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "./calendar";

export function DatePicker({
    date,
    onDateChanged,
    ...props
}: {
    date: Date | undefined;
    onDateChanged: (date: Date | undefined) => void;
    fromDate?: Date;
    disabled?: boolean;
}) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    disabled={props.disabled}
                    variant="outline"
                    data-empty={!date}
                    className="w-[280px] justify-start text-left font-medium data-[empty=true]:text-muted-foreground"
                >
                    <CalendarIcon className={"me-2 h-5 w-5"} />
                    {date ? (
                        DateTime.fromJSDate(date).toLocaleString({ year: "numeric", month: "long", day: "numeric" })
                    ) : (
                        <span>Pick a date</span>
                    )}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar fromDate={props.fromDate} mode="single" selected={date} onSelect={onDateChanged} />
            </PopoverContent>
        </Popover>
    );
}
